import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ErrorPage } from '../ErrorPage';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <ErrorPage
      title={t('notFound.title')}
      message={t('notFound.message')}
      action={{ label: t('notFound.action'), onClick: () => navigate('/discover') }}
    />
  );
}
